import { Auth } from './Auth';
import { Org } from './Org';
import { Journey } from './Journey';
import { Location } from './Location';
import { ServiceType } from './ServiceType';
import { Services } from './Services';
import { Calendar } from './Calendar';
import { Customer } from './Customer';
import { Appointment } from './Appointment';
import { getEnv, envData } from './http-service';
import { ErrorPages } from './ErrorPages';
import { Links } from './Links';
import { ValidateQuestion } from './ValidateQuestion';
import { ValidateAnswer } from './ValidateAnswer';
import { searchQuery } from 'utils';

export const getOnlineBookingApi = (journeyGuid, processGuid, lngCode, executeRecaptcha, clientStateData, customerGUID, journeyGuidFromApi) => {
  const rcaEnabled = parseInt(sessionStorage.rcaEnabled);

  const useMock = searchQuery('m') === 't'

  const params = { journeyGuid, processGuid, lngCode, rcaEnabled, executeRecaptcha, clientStateData, customerGUID, journeyGuidFromApi, useMock };
  return {
    org: Org(params),
    auth: Auth(params), // process guid
    journey: Journey(params),
    location: Location(params),
    customer: Customer(params),
    services: Services(params),
    calendar: Calendar(params), // process guid
    serviceType: ServiceType(params),
    appointment: Appointment(params), // process guid, customer guid
    errorPages: ErrorPages(params),
    links: Links(params), // process guid
    questions: ValidateQuestion(params),
    answers: ValidateAnswer(params)
  };
};

export { getEnv, envData }
